import React from 'react';

/**
 * Mission target — stamped tin badge to match the robot pieces.
 * Filled plate + walnut outline + inner ring + glint. No <defs>/gradients:
 * url(#id) fragment refs break under CRA's <base href>.
 */
function SquareIcon({ color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="100%"
      height="100%"
      style={{ display: 'block' }}
    >
      <rect x="4.6" y="4.6" width="22.8" height="22.8" rx="3.2" fill={color} stroke="#2a1a0e" strokeWidth="1.8" />
      <rect x="10.2" y="10.2" width="11.6" height="11.6" rx="1.8" fill="none" stroke="#fff" strokeOpacity="0.4" strokeWidth="1.6" />
      <circle cx="9.4" cy="8.8" r="1.4" fill="#fff" opacity="0.5" />
    </svg>
  );
}

export default SquareIcon;
